import { render, staticRenderFns } from "./AudienceReport.vue?vue&type=template&id=883d8bfa&"
import script from "./AudienceReport.vue?vue&type=script&lang=js&"
export * from "./AudienceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports